import React from "react";
import { Box } from "@mui/material";
import BasicInfo from "../Widgets/BasicInfo";
import Bio from "../Widgets/Bio";
import EmploymentDetails from "../Widgets/EmploymentDetails";
import { LoadingScreen } from "components/EventScheduling/EventSchedulingUtils";

const ClinicianProfile = (props) => {
  const { userPermissions, isSupervisor, isDirector, isAdmin, isSuperAdmin, ...otherProps } = props;

  if (!otherProps.basicInfo) {
    return <LoadingScreen />;
  }

  return (
    <Box display="flex" justifyContent="center">
      <Box width="80%" maxWidth="1200px" padding={"16px 0px"}>
        {userPermissions?.view_clinician_bio && <Bio {...props} />}
        {userPermissions?.view_clinician_basic_info && <BasicInfo {...props} />}
        {(isDirector || isAdmin || isSuperAdmin || isSupervisor) && (
          <EmploymentDetails {...props} />
        )}
      </Box>
    </Box>
  );
};

export default ClinicianProfile;
